import { Box } from '@mui/material';

interface Props {
  color: string;
}

export function ColorPlate({ color }: Props) {
  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 0.5,
        backgroundColor: color,
      }}
    />
  );
}
